import { gql } from "@apollo/client/core";
import fragments from '../fragments'

export default gql`
    ${fragments.Vehicle.Vehicle_Minimal}
    mutation CreateVehicle(
        $title: String!
        $enterpriseId: ID!
        $fleetId: ID
        $description: String
        $registration: String
    ) {
        createVehicle(
            input: {
                title: $title
                enterpriseId: $enterpriseId
                fleetId: $fleetId
                description: $description
                matriculation: $registration
            }
        ) {
            errors
            status
            statusCode
            vehicle {
                ...Vehicle_Minimal
            }
        }
    }
`
